import GlobeIcon from '@mui/icons-material/Language';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import BoxZoom from './box-zoom.jsx';
import MapPopperButton from './map-popper-button.jsx';
import MapPopper from './map-popper.jsx';
import {resetMap, setDrawTool} from '@explorer/actions/map';
import {MAP_TOOLS} from '@explorer/constants';

const AdditionalZoomTools = ({
  open,
  anchorEl,
  resetMap,
  map,
  placement,
  onChangeTool = () => {},
  drawTool,
  setDrawTool,
}) => {
  const {t} = useTranslation();

  const onClickZoomOutWorld = () => {
    resetMap();
    onChangeTool();
  };

  const onClickBoxZoom = () => {
    setDrawTool({
      name:
        drawTool.name === MAP_TOOLS.BOX_ZOOM
          ? MAP_TOOLS.NONE
          : MAP_TOOLS.BOX_ZOOM,
    });
  };

  return (
    <MapPopper
      title={t('measureTool.title')}
      open={open}
      anchorEl={anchorEl}
      placement={placement}
    >
      <MapPopperButton
        onClick={onClickZoomOutWorld}
        tooltip={t('measureTool.tooltipZoomToWorld')}
        tooltipPosition="top"
        data-qe="zoom-out-to-world"
      >
        <GlobeIcon />
      </MapPopperButton>
      <BoxZoom
        active={drawTool.name === MAP_TOOLS.BOX_ZOOM}
        map={map}
        onClick={onClickBoxZoom}
        onDeactivate={() => setDrawTool(MAP_TOOLS.NONE)}
      />
    </MapPopper>
  );
};

AdditionalZoomTools.propTypes = {
  open: PropTypes.bool,
  anchorEl: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.instanceOf(Element),
  ]),
  map: PropTypes.object,
  placement: PropTypes.string,
  onChangeTool: PropTypes.func,
  resetMap: PropTypes.func,
  drawTool: PropTypes.object,
  setDrawTool: PropTypes.func,
};

const mapStateToProps = state => ({
  drawTool: state.map.drawTool,
});

const mapDispatchToProps = {
  resetMap,
  setDrawTool,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdditionalZoomTools);
